import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent {
    constructor(
        private location: Location,
        private router: Router
    ) {}

    /**
     * Regresa a la página anterior
     */
    goBack(): void {
        this.location.back();
    }

    /**
     * Navega al inicio
     */
    goHome(): void {
        this.router.navigate(['/home']);
    }
}